import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    configInfo:{},
    sum:1
  },
  mutations: {
    // ADDSUM(state,value)
    // {
    //     console.log('value',value)
    //     // state.sum+=value;
    //     let { _this,language } = value;
    //     _this.$apiRequest.getData({language:language}).then(res=>{
    //         console.log('获取信息',res)
    //         if(res.code==1){
    //             state.list=res.data
    //             // _this.list=res.data
    //             // console.log('_this.list',_this.list)
    //         }
    //     })
    // }
    setResturantName:(state, payload) =>{
        let { _this,language } = payload;
        _this.$apiRequest.getData({language:language}).then(res=>{
            console.log('获取信息',res)
            if(res.code==1){
                state.configInfo=res.data
                // _this.list=res.data
                // console.log('_this.list',_this.list)
            }
        })

    }
  },
  actions: {
    addSum(context,value)
    {
        context.commit('ADDSUM',value);
    }

  },
  modules: {}
});



// WEBPACK FOOTER //
// ./src/store/index.js